import React, { useEffect, useState } from 'react';
import { Download, X, Sparkles } from 'lucide-react';
import { promptInstall, isInstallReady } from '@/lib/pwa';

const DISMISS_KEY = 'gt_install_dismissed';

export default function InstallPrompt() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(DISMISS_KEY);
    if (dismissed) return;
    if (isInstallReady()) setShow(true);
    const onReady = () => setShow(true);
    const onInstalled = () => setShow(false);
    window.addEventListener('gt:installable', onReady);
    window.addEventListener('gt:installed', onInstalled);
    return () => {
      window.removeEventListener('gt:installable', onReady);
      window.removeEventListener('gt:installed', onInstalled);
    };
  }, []);

  if (!show) return null;

  const onInstall = async () => {
    const result = await promptInstall();
    if (result.outcome === 'accepted' || result.outcome === 'dismissed') {
      setShow(false);
      if (result.outcome === 'dismissed') localStorage.setItem(DISMISS_KEY, '1');
    }
  };
  const onDismiss = () => {
    setShow(false);
    localStorage.setItem(DISMISS_KEY, '1');
  };

  return (
    <div className="puvio-card p-4 flex items-center gap-3" data-testid="install-prompt">
      <div className="w-11 h-11 rounded-2xl bg-[#15291C] flex items-center justify-center shadow-[0_8px_22px_rgba(56,189,248,0.4)]">
        <Sparkles className="w-5 h-5 text-[#C4FF3D]" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-bold text-sm text-[#0F1A13]">Install Trivly</p>
        <p className="text-[12px] text-[#4A5A50] leading-snug">Add to your home screen — works offline too.</p>
      </div>
      <button type="button" onClick={onInstall} className="px-3 py-2 rounded-full bg-gradient-to-r from-[#15291C] to-[#1F3A29] text-[#0F1A13] text-[12px] font-bold flex items-center gap-1.5 gt-focus" data-testid="install-prompt-cta">
        <Download className="w-3.5 h-3.5" /> Install
      </button>
      <button type="button" onClick={onDismiss} aria-label="Dismiss" className="w-8 h-8 rounded-full bg-[#0F1A13]/05 border border-[#0F1A13]/10 text-[#4A5A50] flex items-center justify-center gt-focus" data-testid="install-prompt-dismiss">
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
